export enum SheetValueStatus {
  OK = 'OK',
  CALCULATION_ERROR = 'CALCULATION_ERROR',
  WAITING_FOR_METRIC_CALC = 'WAITING_FOR_METRIC_CALC',
}

export enum SpreadsheetValueType {
  PLAIN = 'PLAIN',
  BOOLEAN = 'BOOLEAN',
  PERCENTAGE = 'PERCENTAGE',
  CURRENCY_TR = 'CURRENCY_TR',
}
